import { z } from 'zod';
import { $getFiltersRequestType } from '@shared/types';

const $Currency = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  value: z.string(),
});

export type GetCurrenciesRequest = z.infer<typeof $GetCurrenciesRequest>;
export const $GetCurrenciesRequest = $getFiltersRequestType(z.object({}));

export const $GetCurrenciesResponse = z.array($Currency);

export type GetCurrenciesResponse = z.infer<typeof $GetCurrenciesResponse>;
